import React from 'react';

import { Footer } from '../../styles';

import LogoMercadoPago from '../../assets/img/mercado-pago-logo.png';

export default () => {
  return (
    <Footer>
      <a
        style={{ flexShrink: 0, marginRight: '20px' }}
        href="https://fotofun.top/smart/#faq"
        title="Ver termos de uso"
      >
        Perguntas frequentes
      </a>
      <div
        style={{
          textAlign: 'right',
          lineHeight: 1.6,
        }}
      >
        Tecnologia do{' '}
        <img
          style={{ verticalAlign: 'middle', marginLeft: '10px' }}
          width={100}
          alt="Mercado Pago"
          src={LogoMercadoPago}
        />
      </div>
    </Footer>
  );
};
